import createModel from "../createModel";

export const ExternalEpinResult = createModel("ExternalEpinResult", (json) => ({
    phoneNumberShort: json.PhoneNumberShort,
    resendEpinCountExhausted: json.ResendPinCountExhausted,
    invalidHash: json.InvalidHash,
}));
